export default __webpack_public_path__ + "static/media/login-lock.193c7769.svg";